import { appLinks } from "./app-links.ts";
import { h } from "./dom.ts";

/**
 * The top of the site when today's photo can't be shown: none for the visitor's date yet, or it
 * didn't load (then `retry` offers another go).
 */
export function showNoDaily(root: HTMLElement, urls: { appStoreUrl: string; playStoreUrl: string }, retry?: () => void): void {
  const heading = h("h1", { tabindex: "-1" }, retry ? "Today's photo didn't load" : "Today's photo isn't ready yet");
  const again = retry && h("button", { class: "primary", type: "button" }, "Try again");
  again?.addEventListener("click", retry!);
  root.replaceChildren(
    h("div", { class: "page unavailable" },
      h("p", { class: "wordmark" }, "Where in the World?"),
      heading,
      h("p", { class: "soft" }, retry ? "Check your connection and try again." : "It'll be here soon. Come back a little later."),
      again ?? appLinks(urls, "Get the free app", "primary")));
  heading.focus();
}
